<template>
  <v-menu offset-y>
    <v-btn slot="activator" icon :style="{color,backgroundColor}" flat :title="$t('Pilot.FleetDrawer.SelectCustomFleetColorTooltip')" >
      <v-icon>mdi-palette</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile v-for="style in stylesList" :key="style.name" 
                   @click="store.myActions.UI_SET_ITEM_MAP_STYLE({uiid:uiid,style})">
        <v-list-tile-avatar :class="style.name" size="25" small :color="style.color"></v-list-tile-avatar>
        <v-list-tile-title>{{$t(`Color.${style.name}`)}}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script setup lang="ts">
  
  import { computed } from 'vue'
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import { stylesList, defaultMapStyle } from '@/components/map/MapStyles'
  import store from '@/store'

  const props = defineProps<{    
    fleet: AloDbFleet,
    uiid: string
  }>()

  const fleetState = computed(()=> store.myGetters.fleetUiStateByUiid(props.uiid))  
         
  const color = computed(() => {
    const nameColor = (fleetState.value && fleetState.value.mapStyles && fleetState.value.mapStyles.name)
      ? fleetState.value.mapStyles.name 
      : defaultMapStyle.name
    return nameColor === 'Default' ? '#000000' : stylesList.find((c: any) => c.name === nameColor)?.color || '#000000'        
  })

  const backgroundColor = computed(() => {
    return color.value === '#ffffff' ? '#000000' : '#ffffff'
  })

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.White>div{
  border: solid 2px #000!important;
}
</style>
